import { useState, useMemo, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useLocation } from 'react-router-dom';

// 사이드바에서 직접 진입할 수 없는 경로의 폴백 제목 (사이드바 라벨이 없을 때만 사용)
const fallbackTitles = {
  '/': '대시보드',
  '/product-estimate': '제품 견적서',
  '/service-estimate': '서비스견적서',
  '/product-estimate/new': '제품 견적서 작성',
  '/service-estimate/new': '서비스 견적서 작성',
  '/approvals': '승인상태',
  '/bundles': '제품 묶음',
  '/bundles/new': '새 묶음 만들기',
  '/products': '상품 관리',
  '/products/new': '상품 등록',
  '/parts': '자재 관리',
  '/services': '서비스 관리',
  '/services/new': '서비스 등록',
  '/survey-jobs': '직무별 가격 관리',
  '/customers': '고객 관리',
  '/organization': '조직 관리',
  '/users': '사용자관리',
  '/audit-logs': '감사 로그',
  '/settings': '설정',
};

export default function AppLayout() {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('sidebar_collapsed') === 'true');
  const [sidebarMenuItems, setSidebarMenuItems] = useState(null);

  const toggleSidebar = () => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem('sidebar_collapsed', String(next));
  };

  const handleMenuItemsChange = useCallback((items) => setSidebarMenuItems(items), []);

  // 현재 path 가 사이드바 메뉴에 있으면 그 라벨을 사용, 아니면 fallback
  const title = useMemo(() => {
    if (sidebarMenuItems) {
      for (const section of sidebarMenuItems) {
        const hit = (section.items || []).find(it => it.path === location.pathname);
        if (hit) return hit.label || fallbackTitles[location.pathname] || '';
      }
    }
    return fallbackTitles[location.pathname] || '';
  }, [sidebarMenuItems, location.pathname]);

  // iframe(나란히 보기 등) 안에서는 사이드바·상단바 없이 본문만 표시
  const embedded = (() => { try { return window.self !== window.top; } catch (e) { return true; } })();
  if (embedded) return <div className="page-content"><Outlet /></div>;

  return (
    <div className="app-layout">
      <Sidebar collapsed={collapsed} onToggle={toggleSidebar} onMenuItemsChange={handleMenuItemsChange} />
      <div className={`main-content${collapsed ? ' collapsed' : ''}`}>
        <Topbar title={title} />
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
